<template>
  <div class="news-wrapper">

    <Head :title="$tc('header.back')" :lanshow="ActiveName" />
    <!-- <NavBar /> -->
    <div class="news-inner">
      <h5 class="mianbaoxie">
        <span> 当前地址：</span><span> 首页 </span>

        <span v-if="$route.query.name"> > {{ $route.query.name }}</span>
        <span> > 文章详情</span>
      </h5>
      <news-detail :detaildata="detailData"></news-detail>
      <Empty :emptydata="emptydata" v-if="emptydata" />
    </div>
    <Footer />
  </div>
</template>

<script>
import NewsDetail from '@/components/NewsDetail.vue'

import { mapMutations, mapState } from 'vuex'

export default {
  name: 'News',
  data () {
    return {
      id: '',
      expireSign: '',
      detailData: null,
      emptydata: null
    }
  },
  components: {
    NewsDetail
  },
  created () {
    this.id = this.$route.params.id
    this.$route.query.expireSign &&
      (this.expireSign = this.$route.query.expireSign)
    this.getDate()
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
  },
  beforeRouteLeave (to, form, next) {
    this.$Common
      .track('unload', {
        name: this.detailData && this.detailData.title,
        id: this.id,
        type: '资讯'
      })
      .then(() => {
        next()
      })
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName']),
    getDate () {
      this.$Api
        .getNewsDetail({
          newsId: this.id
        })
        .then((data) => {
          if (data) {
            data.item && (this.detailData = data.item)
            data.share && this.share(data.share)
            data.item &&
              this.$Common.track('load', {
                title: data.item.title,
                id: this.id,
                type: '资讯'
              })
          } else {
            this.emptydata = {
              type: 'nodata'
            }
          }
          this.setShowLoading(false)
          if (data.item.videoLabelRelateList && data.item.videoLabelRelateList[0]) {
            data.item.videoAiLabels = data.item.videoLabelRelateList[0].labelRelateList.filter(item => item.labelId != -1)
          }
        })
        .catch((err) => {
          if (err === 404) {
            this.emptydata = {
              type: 'nodata'
            }
          } else {
            this.emptydata = {
              type: 'nonetwork'
            }
          }
          this.setShowLoading(false)
        })
    },
    share (obj) {
      this.$nextTick(() => {
        this.$Common.onshare(obj)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$Common.pageShare()
    })
  }
}
</script>
<style lang="scss" scoped>
.news-wrapper {
  height: 100%;
  margin-top: 11vw;
  width: 100%;
  .news-inner {
    min-height: 77%;
  }
  h5 {
    background-color: #f6f8fa;
  }
}
</style>
